import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.define-property";
import { __decorate, __extends } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import ShopList from './shopList/index.vue';
import ShopDefaultTheme from './shopDefaultTheme/index.vue';
import ShopDefaultThemeRecord from './shopDefaultThemeRecord/index.vue';

var ShopManagePage = function (_super) {
  __extends(ShopManagePage, _super);

  function ShopManagePage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.tabList = [{
      value: 'ShopList',
      text: _this.t('店铺列表'),
      _permissionKey: 'shop_list'
    }, {
      value: 'ShopDefaultTheme',
      text: _this.t('店铺默认主体'),
      _permissionKey: 'shop_default_body'
    }, {
      value: 'ShopDefaultThemeRecord',
      text: _this.t('默认主体明细纪录'),
      _permissionKey: 'shop_default_body_record'
    }];
    _this.activeTab = '';
    return _this;
  }

  Object.defineProperty(ShopManagePage.prototype, "showTabList", {
    get: function get() {
      return this.$util.filterListPermission(this.tabList);
    },
    enumerable: false,
    configurable: true
  });

  ShopManagePage.prototype.activeTabChange = function () {
    var querys = this.$route.query;
    var newQuery = Object.assign(this.$util.deepCopy(querys), {
      tab: this.activeTab
    });
    this.$router.push({
      name: 'ShopManagePage',
      query: newQuery,
      params: this.$route.params
    });
  };

  ShopManagePage.prototype.handleActiveTaChange = function (val) {
    this.activeTab = val;
    this.activeTabChange();
  };

  ShopManagePage.prototype.created = function () {
    var _a;

    var tab = this.$route.query.tab;

    if (tab && this.$util.findItemByKeyValue(this.showTabList, tab, 'value')) {
      this.activeTab = tab;
    } else {
      this.activeTab = (_a = this.tabList[0]) === null || _a === void 0 ? void 0 : _a.value;
    }
  };

  ShopManagePage = __decorate([Component({
    components: {
      ShopList: ShopList,
      ShopDefaultTheme: ShopDefaultTheme,
      ShopDefaultThemeRecord: ShopDefaultThemeRecord
    },
    beforeRouteEnter: function beforeRouteEnter(to, from, next) {
      next(function (vm) {
        vm.activeTabChange();
      });
    }
  })], ShopManagePage);
  return ShopManagePage;
}(Vue);

export default ShopManagePage;